import { FilterArrayType } from 'common/components/Filters';

export const toInvoiceSigningFilterVariableExport = (
  filterList: FilterArrayType[]
) => {
  const keyMapping: { [key: string]: string } = {
    corporatePeriodId: 'filterAccountingPeriodId',
    businessUnitId: 'filterBusinessUnitId',
    _companyId: 'filterCompanyId',
    currencyId: 'filterCurrencyId',
    departmentId: 'filterDepartmentId',
    filterMultiStatusTypes: 'filterMultiStatusTypes',
    filterSupplierId: 'filterSupplierId',
    transactionTypeId: 'filterTransactionTypeId',
  };

  const filterVariablesList = filterList.reduce((acc, { filterKey, value }) => {
    const newKey = keyMapping[filterKey];
    if (newKey) {
      acc[newKey] = value;
    }
    return acc;
  }, {} as { [key: string]: string | number | boolean | any[] });

  return filterVariablesList;
};
